import React from 'react';
import '../css/userMenu.css'
import { useNavigate } from 'react-router-dom';

const UserMenu = () => {
    const navigate = useNavigate();
    const handleLogout = () => {
        navigate('/');
    }
    return (
        <div className='user-menu-wrapper'>
            <ul>
                <li>
                    <button className='user-menu-item' onClick={handleLogout}>
                        Salir
                    </button>
                </li>
            </ul>
        </div>
    );
}

export default UserMenu;
